<div class="container align-middle">
    <div><br></div>
    <div class="justify-content-md-left">
        <mat-card>
            <mat-card-content class="mat-typography" style="color: #041427">
                <h1>
                    <p align="center"><b>Privacy Policy</b></p>
                </h1>
                <h3 style="color: #4372AA">
                    <p align="justify">Your privacy is critically important to us. At KSolve, we have a few fundamental
                        principles:</p>
                    <ul>
                        <li>We don’t ask you for personal information unless we truly need it. (We can’t stand services
                            that ask you for things like your gender or income level for no apparent reason.)</li>
                        <li>We don’t share your personal information with anyone except to comply with the law,
                            develop our products, or protect our rights.</li>
                        <li>We don’t store personal information on our servers unless required for the on-going
                            operation of one of our services.</li>
                        <li>In our products, we aim to make it as simple as possible for you to control what’s
                            visible to the public, seen by search engines, kept private, and permanently deleted.
                        </li>
                    </ul>
                    <p align="justify">Below is our privacy policy which incorporates these goals: </p>
                    <p align="justify">If you have questions about deleting or correcting your personal data please
                        contact us(see
                        the details on "Contact Us" page www.ksolve.com)</p>
                </h3>
                <h2>
                    <p><b>Website and Mobile Application Visitors and Users</b></p>
                </h2>
                <h3 style="color: #4372AA">
                    <p align="justify">Like most website and mobile application vendors, KSolve collects
                        non-personally-identifying
                        information of the sort that web browsers, servers and mobile OS typically make available,
                        such as the mobile platform and website related metadata, like browser type, language
                        preference, referring site, and the date and time of each visitor request. KSolve’s purpose
                        in collecting non-personally identifying information is to better understand how KSolve’s
                        visitors use its website and mobile applicatoions. From time to time, KSolve may release
                        non-personally-identifying information in the aggregate, e.g., by publishing a report on
                        trends in the usage of its website and mobile applications.</p>
                    <p>KSolve may also collect potentially personally-identifying information like Internet Protocol
                        (IP) addresses for logged in users and for users leaving comments. KSolve only discloses
                        logged in user and commenter IP addresses under the same circumstances that it uses and
                        discloses personally-identifying information as described below, except that blog commenter
                        IP addresses and email addresses are visible and disclosed to the administrators of the site
                        where the comment was left.</p>
                </h3>
                <h2>Gathering of Personally-Identifying Information</h2>
                <h3 style="color: #4372AA">
                    <p align="justify">ertain visitors and users choose to interact with KSolve in ways that require
                        KSolve to
                        gather personally-identifying information. The amount and type of information that KSolve
                        gathers depends on the nature of the interaction. Those who engage in transactions with
                        KSolve, may be asked to provide additional information, including as necessary the personal
                        and financial information required to process those transactions. In each case, KSolve
                        collects such information only as is necessary or appropriate to fulfill the purpose of the
                        user interaction with KSolve. KSolve does not disclose personally-identifying information
                        other than as described below. And users can always refuse to supply personally-identifying
                        information, with the caveat that it may prevent them from engaging in certain website or
                        mobile application activities.</p>
                </h3>

                <h2>Aggregated Statistics</h2>
                <h3 style="color: #4372AA">
                    <p align="justify">KSolve may collect statistics about the behavior of visitors to its websites. For
                        instance,
                        KSolve may monitor the most popular blogs on the KSolve.com site or use spam screened by the
                        Akismet service to help identify spam. KSolve may display this information publicly or
                        provide it to others. However, KSolve does not disclose personally-identifying information
                        other than as described below.</p>
                </h3>

                <h2>Protection of Certain Personally-Identifying Information</h2>
                <h3 style="color: #4372AA">
                    <p align="justify">KSolve discloses potentially personally-identifying and personally-identifying
                        information
                        only to those of its employees, contractors and affiliated organizations that (i) need to
                        know that information in order to process it on KSolve’s behalf or to provide services
                        available at KSolve’s websites, and (ii) that have agreed not to disclose it to others. Some
                        of those employees, contractors and affiliated organizations may be located outside of your
                        home country; by using KSolve’s websites, you consent to the transfer of such information to
                        them. KSolve will not rent or sell potentially personally-identifying and
                        personally-identifying information to anyone. Other than to its employees, contractors and
                        affiliated organizations, as described above, KSolve discloses potentially
                        personally-identifying and personally-identifying information only in response to a
                        subpoena, court order or other governmental request, or when KSolve believes in good faith
                        that disclosure is reasonably necessary to protect the property or rights of KSolve, third
                        parties or the public at large. If you are a registered user of an KSolve website and have
                        supplied your email address, KSolve may occasionally send you an email to tell you about new
                        features, solicit your feedback, or just keep you up to date with what’s going on with
                        KSolve and our products. We primarily use our website/mobile applications to communicate
                        this type of information, so we expect to keep this type of email to a minimum. If you send
                        us a request (for example via a support email or via one of our feedback mechanisms), we
                        reserve the right to publish it in order to help us clarify or respond to your request or to
                        help us support other users. KSolve takes all measures reasonably necessary to protect
                        against the unauthorized access, use, alteration or destruction of potentially
                        personally-identifying and personally-identifying information.</p>
                </h3>
                <h2>Cookies</h2>
                <h3 style="color: #4372AA">
                    <p align="justify">A cookie is a string of information that a website stores on a visitor’s
                        computer, and that
                        the visitor’s browser provides to the website each time the visitor returns. KSolve uses
                        cookies to help KSolve identify and track visitors, their usage of KSolve website, and their
                        website access preferences. KSolve visitors who do not wish to have cookies placed on their
                        computers should set their browsers to refuse cookies before using KSolve’s websites, with
                        the drawback that certain features of KSolve’s websites may not function properly without
                        the aid of cookies.</p>
                </h3>
                <h2>Business Transfers</h2>
                <h3 style="color: #4372AA">
                    <p align="justify">If KSolve, or substantially all of its assets, were acquired, or in the unlikely
                        event that
                        KSolve goes out of business or enters bankruptcy, user information would be one of the
                        assets that is transferred or acquired by a third party. You acknowledge that such transfers
                        may occur, and that any acquirer of KSolve may continue to use your personal information as
                        set forth in this policy.</p>
                </h3>
                <h2>Ads</h2>
                <h3 style="color: #4372AA">
                    <p align="justify">Ads appearing on any of our websites may be delivered to users by advertising
                        partners, who
                        may set cookies. These cookies allow the ad server to recognize your computer each time they
                        send you an online advertisement to compile information about you or others who use your
                        computer. This information allows ad networks to, among other things, deliver targeted
                        advertisements that they believe will be of most interest to you. This Privacy Policy covers
                        the use of cookies by KSolve and does not cover the use of cookies by any advertisers.</p>
                </h3>
                <h2>Privacy Policy Changes</h2>
                <h3 style="color: #4372AA">
                    <p align="justify">Although most changes are likely to be minor, KSolve may change its Privacy
                        Policy from time
                        to time, and in KSolve’s sole discretion. KSolve encourages visitors/users to frequently
                        check this page for any changes to its Privacy Policy. If you have a KSolve account, you
                        should also check your dashboard for alerts to these changes. Your continued use of this
                        site and mobile applications after any change in this Privacy Policy will constitute your
                        acceptance of such change.</p>
                </h3>

            </mat-card-content>
        </mat-card>
    </div>
</div>